<template>
  <app-content>
    <pairing-detail-dialog
        v-if="detailItem"
        :item="detailItem.pairingDetails"
        @refreshDetailItem="refreshDetailItem"
    />
    <form action="#">
      <div class="inner">
        <app-content-title v-if="item !== null" :title="item.name" />
      </div>

      <app-settings v-if="item !== null" :disabled="pending">
        <app-settings-content>
          <app-settings-desc :title="translations.basicInfo">
            <p>
              <translate>Založeno</translate>:
              <br />
              <span v-html="formatDateAdvanced(item._created)" />
            </p>
            <p>
              <translate>Poslední změna</translate>:
              <br />
              <span v-html="formatDateAdvanced(item._updated)" />
            </p>
            <a v-if="isPairingDetails" @click="selectDetailItem()" class="pairing_info" title="Zobrazit informace o párování">Zobrazit informace o párování</a>
          </app-settings-desc>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.name"
                  name="name"
                  v-model="item.name"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.id"
                  name="id"
                  v-model="item._id"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.importId"
                  name="importId"
                  v-model="item.importId"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.episodeName"
                  name="episodeName"
                  v-model="item.episodeName"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.start"
                  name="durationMinutes"
                  :value="formatDateEpg(item.start)"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.durationMinutes"
                  name="durationMinutes"
                  v-model="item.durationMinutes"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.tvStation"
                  name="tvStation"
                  :value="item.tvStation ? item.tvStation.name : ''"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.year"
                  name="year"
                  v-model="item.year"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.rating"
                  name="rating"
                  v-model="item.rating"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.state"
                  name="state"
                  v-model="item.state"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.live"
                  name="live"
                  v-model="item.live"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_right">
              <app-input
                  :label="translations.isPeriodical"
                  name="isPeriodical"
                  v-model="item.isPeriodical"
                  readonly
              />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-settings-input
                  :label="translations.shortDescription"
              >
                <app-textarea
                    name="descriptionShort"
                    rows="6"
                    v-model="item.descriptionShort"
                    readonly
                />
              </app-settings-input>
            </app-settings-col>
            <app-settings-col class="field_right">
              <app-settings-input
                  :label="translations.longDescription"
              >
                <app-textarea
                    name="descriptionLong"
                    rows="6"
                    v-model="item.descriptionLong"
                    readonly
                />
              </app-settings-input>
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>

        <app-settings-content class="sync" v-if="item.show">
          <div class="left">
            <h2 v-translate>Pořad</h2>
          </div>
          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  :label="translations.name"
                  name="showName"
                  :value="item.show ? item.show.name : ''"
                  readonly
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.id"
                  name="showId"
                  :value="item.show ? item.show._id : ''"
                  readonly
              />
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>
        <section class="buttons">
          <p>
            <a
                @click="$router.back()"
            >
              {{ translations.list }}
            </a>
          </p>
        </section>
      </app-settings>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import ContentItem from 'components/AppContent'
import PairingDetailDialog from '@/components/PairingDetailDialog'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Broadcast',
  enums: true
})

export default {
  name: 'broadcast',
  components: {
    PairingDetailDialog,
    ContentItem
  },
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      detailItem: null
    }
  },
  computed: {
    translations() {
      return {
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Název'),
        importId: this.$gettext('Importní ID'),
        id: this.$gettext('ID'),
        episodeName: this.$gettext('Název epizody'),
        start: this.$gettext('Začátek'),
        durationMinutes: this.$gettext('Délka (min)'),
        tvStation: this.$gettext('TV stanice'),
        year: this.$gettext('Rok'),
        rating: this.$gettext('Hodnocení'),
        state: this.$gettext('Stav'),
        shortDescription: this.$gettext('Krátný popis'),
        longDescription: this.$gettext('Dlouhý popis'),
        list: this.$gettext('Seznam'),
        isPeriodical: this.$gettext('Periodický'),
        live: this.$gettext('Live')
      }
    },
    currentTitle() {
      if (this.item !== null) {
        return [
          this.item.name
        ]
      } else {
        return ''
      }
    },
    isPairingDetails() {
      return this.item.pairingDetails === undefined || this.item.pairingDetails.length === undefined
    }
  },
  methods: {
    selectDetailItem() {
      this.detailItem = this.item
    },
    refreshDetailItem() {
      this.detailItem = null
    }
  }
}
</script>
